import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Avatar, Box, Typography } from '@mui/material';
import dayjs from 'dayjs';
import moment from 'moment';

const employees = [
  {
    id: '1',
    fullName: 'Darlene Robertson',
    image: '',
    profession: 'Brow artist',
    bookings: [{
      from: '03:00',
      to: '04:00',
      title: 'Shellac',
    }]
  },
  {
    id: '2',
    fullName: 'Jane Doe',
    image: '',
    profession: 'Brow artist',
    bookings: [{
      from: '03:00',
      to: '04:30',
      title: 'Shellac',
    }]
  },
];

const studioBookings = [{
  from: '01:00',
  to: '03:00',
  title: 'Not working time'
}, {
  from: '05:30',
  to: '06:30',
  title: 'Break'
}]

const times = ['1am', '2am', '3am', '4am', '5am', '6am', '7am', '8am', '9am', '10am', '11am', '12pm', '1pm', '2pm', '3pm', '4pm', '5pm', '6pm', '7pm', '8pm', '9pm', '10pm', '11pm', '12am'];

const headerRowHeight = 70;
const timeRowHeight = 80;
const cellWidth = 200;
const timeCellWidth = 45;

const Bookings = ({
                    width: canvasWidth,
                    height: canvasHeight,
                    employees,
                    shouldShowTimeline,
}: any) => {
  const paddingsLeftOffset = 8;
  const paddingsTopOffset = 8;

  const getHours = (str: string) => +str.split(':')[0];

  const renderBooking = (booking: any, positionIndex: number) => {
    const {service} = booking.services[0];
    const {duration} = service;

    const timeFrom = dayjs(booking.from).format('HH:mm');
    const timeTo = dayjs(booking.from).add(duration, 'minutes').format('HH:mm');

    const minutes = duration;

    // @todo add checking on last index (e.g. 00:00 it's 23 index)
    const timePositionIndex = getHours(dayjs(booking.from).format('HH:mm')) - 1;

    // should be 80 per hour;
    const height = Math.round(minutes * 1.334) - paddingsTopOffset;
    const width = cellWidth - paddingsLeftOffset;

    const leftOffset = timeCellWidth;
    const topOffset = headerRowHeight;

    const leftPositionOffset = positionIndex * cellWidth;
    const topPositionOffset = timePositionIndex * timeRowHeight;

    const leftPosition = leftOffset + leftPositionOffset + paddingsLeftOffset / 2 - 1;
    const topPosition = topOffset + topPositionOffset + paddingsTopOffset / 2 - 1;

    const shouldShowInOneLine = height < timeRowHeight / 2;

    // completed style
    let style = {
      backgroundColor: '#F3F3F3',
      color: '#828282',

      '&:hover': {
        backgroundColor: '#EDEDED',
      },
    } as any;

    if (booking.status !== 'completed' && !booking.payed) {
      style = {
        backgroundColor: '#fff',
        color: '#1F6AD4',
        border: '1px solid #1F6AD4',
        '&:hover': {
          backgroundColor: '#FBFCFF',
        },
      }
    } else if (booking.status !== 'completed' && booking.payed) {
      style = {
        backgroundColor: '#eff2fe',
        color: '#1F6AD4',
        '&:hover': {
          backgroundColor: '#E3E9FF',
        },
      };
    }

    return (
      <Box sx={{
        width,
        height,
        borderRadius: '6px',
        position: 'absolute',
        top: topPosition,
        left: leftPosition,
        ...style
      }}>
        <Box sx={{
          padding: '4px 8px',
          ...(shouldShowInOneLine ? {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          } : {}),
        }}>
          <Typography sx={{
            fontWeight: '700',
            fontSize: '14px',
          }}>
            {service.title}
          </Typography>
          <Typography sx={{
            fontWeight: '400',
            fontSize: '12px',
          }}>
            {`${timeFrom} - ${timeTo}`}
          </Typography>
        </Box>
      </Box>
    );
  };

  const renderBookings = () => {
    return employees.map((el: any, index: number) => {
      return (
        <>
          {el.bookings.map((booking: any) => {
            return (
              <Box key={booking.id}>
                {renderBooking(booking, index)}
              </Box>
            )
          })}
        </>
      );
    });
  };

  const renderTimeline = () => {
    const timeNow = moment();
    const minutes = timeNow.minutes();

    // @todo add checking on last index (e.g. 00:00 it's 23 index)
    const timePositionIndex = timeNow.hours() - 1;

    const leftOffset = timeCellWidth;
    const topOffset = headerRowHeight;

    const width = cellWidth * employees.length;


    const topPositionOffset = timePositionIndex * timeRowHeight;

    const leftPosition = leftOffset;
    const topPosition = topOffset + topPositionOffset + Math.round(minutes * 1.334);

    return (
      <Box sx={{
        width,
        height: '1px',
        background: '#BF295C',
        borderRadius: '6px',
        position: 'absolute',
        top: topPosition,
        left: leftPosition,
      }}>
        <Box sx={{
          width: '5px',
          height: '5px',
          background: '#BF295C',
          borderRadius: '5px',
          position: 'absolute',
          top: '-2px',
          left: '-3px',
        }}/>
      </Box>
    );
  }


  return (<Box sx={{
    position: 'absolute',
    height: canvasHeight,
    width: canvasWidth,
  }}>
    {renderBookings()}
    {/*{renderStudioBookings()}*/}
    {shouldShowTimeline ? renderTimeline() : null}
  </Box>);
}

export const Timesheet = ({
  date,
}: any) => {
  const { bookings } = useSelector((state: any) => state.bookings);
  const shouldShowTimeline = date.format('YYYY-MM-DD') === dayjs().format('YYYY-MM-DD');

  const employeesObj = {} as any;
  bookings.forEach((booking: any) => {
    if (employeesObj[booking.master.id]) {
      employeesObj[booking.master.id].push(booking);
    } else {
      employeesObj[booking.master.id] = [booking];
    }
  });

  const normalizedEmployees = Object.values(employeesObj).map((val: any) => ({
    ...val[0].master,
    bookings: val
      .filter((booking: any) => dayjs(booking.from).format('YYYY-MM-DD') === date.format('YYYY-MM-DD'))
      .map((el: any) => el),
  })).filter((el: any) => el.bookings.length);

  const renderEmptyCells = () => {
    return normalizedEmployees.map(({id}) => {
      return (
        <Box key={id} sx={{
          height: '40px',
          width: '200px',
          minWidth: '200px',
          borderRight: '1px solid #EEEEEE',
          borderBottom: '1px solid #eee',
        }} />
      );
    });
  };

  const renderTimesheetRow = (title: string) => {
    return (
      <>
        <Box sx={{
          display: 'flex',
        }}>
          <Box sx={{
            height: '40px',
            width: '45px',
            minWidth: '45px',
            borderRight: '1px solid #EEEEEE',
            borderBottom: '1px solid #eee',
            display: 'flex',
            justifyContent: 'flex-end',
          }}>
            <Typography sx={{
              color: '#1C1D21',
              fontSize: '12px',
              fontWeight: '500',
              marginRight: '6px',
            }}>
              {title}
            </Typography>
          </Box>
          {renderEmptyCells()}
        </Box>
        <Box sx={{
          display: 'flex',
        }}>
          <Box sx={{
            height: '40px',
            width: '45px',
            minWidth: '45px',
            borderRight: '1px solid #EEEEEE',
            borderBottom: '1px solid #EEEEEE',
          }}/>
          {renderEmptyCells()}
        </Box>
      </>
    );
  };


  const getTimelineCanvasDimensions = (employees: any) => {
    const height = headerRowHeight + timeRowHeight * times.length;
    const width = timeCellWidth + cellWidth * employees.length;

    return {
      height,
      width,
    }
  }

  const { width, height } = getTimelineCanvasDimensions(normalizedEmployees);

  return (
    <Box sx={{
      width: '%100',
      height: 600,
      overflow: 'auto',
      position: 'relative',
    }}>
      <Bookings
        width={width}
        height={height}
        employees={normalizedEmployees}
        shouldShowTimeline={shouldShowTimeline}
      />
      {/*header row*/}
      <Box sx={{
        height: 70,
        marginLeft: '44px',
        width: '100%',
        display: 'flex',
      }}>
        {
          normalizedEmployees.map(({
                                     id,
                                     photo,
                                     firstName,
                                     lastName,
                                     profession,
          }: any) => {
            return (
              <Box
                key={id}
                sx={{
                  height: 70,
                  minWidth: 200,
                  maxWidth: 200,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderLeft: '1px solid #eee',
                  borderBottom: '1px solid #eee',
                }}>
                <Box sx={{
                  display: 'flex',
                  minWidth: 176,
                  maxWidth: 176,
                  flexDirection: 'row',
                  alignItems: 'center',
                }}>
                  <Avatar
                    src={photo}
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: '6px',
                      marginRight: '8px',
                    }}
                  />
                  <Box>
                    <Typography sx={{
                      color: '#1F1F1F',
                      fontSize: '14px',
                      fontWeight: '500',
                    }}>{`${firstName} ${lastName}`}</Typography>
                    <Typography sx={{
                      color: '#828282',
                      fontSize: '12px',
                      fontWeight: '500',
                    }}>{profession}</Typography>
                  </Box>
                </Box>
              </Box>
            );
          })
        }

      </Box>

      {/* timeline content */}
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
      }}>
        {
          times.map(timeStr => {
            return renderTimesheetRow(timeStr)
          })
        }
      </Box>

    </Box>
  );
};
